import React from 'react';
import { PaddingType } from '../../../puck/reusable-props/padding';
import { CustomizeProps } from '../../../interface/commonInterface';
import { getIsEdit } from '../../../utils/constants';
import { IBorderValueProps } from '../../../puck/reusable-props/Border';
import { getBorderProps, getPaddingStyles } from '../../../utils/helper';
import {
  ReduxDispatchProps,
  ReduxSelectorProps,
} from '../../../services/constants';
import {
  setCheckoutErrorMessage,
  setIsTermsAccepted,
} from '../../../redux/slices/commonSlice';
import { setCartData, setIsCartLoading } from '../../../redux/slices/cartSlice';
import checkoutService from '../../../api/checkoutService';
import {
  ShippingMethod,
  UpSellData,
} from '../../../interface/checkoutInterface';
import { setAvailableShippingMethods } from '../../../redux/slices/checkoutSlice';

interface AgreeAndContinueButtonProps
  extends ReduxDispatchProps,
    ReduxSelectorProps {
  showVip: boolean;
  Button: CustomizeProps;
  ButtonText: CustomizeProps;
  currentDeviceType: string;
  styles: {
    backgroundColor: string;
    hoverColor: string;
    border: IBorderValueProps;
    width: string;
    padding: PaddingType;
  };
}

export const AgreeAndContinueButton: React.FC<AgreeAndContinueButtonProps> = ({
  showVip,
  styles,
  Button,
  ButtonText,
  currentDeviceType,
  useAppDispatch,
  useAppSelector,
}) => {
  const isEditPage = getIsEdit();
  const dispatch = useAppDispatch();
  const { cartData } = useAppSelector(state => state.cart);
  const storeData = useAppSelector(state => state.store.storeData);
  const addProduct = useAppSelector(
    state => state.common.variantIdToAddIsTermsAccepted,
  );
  const isCartLoading = useAppSelector(state => state.cart.isCartLoading);
  const { isSetShippingApiLoading, pageId } = useAppSelector(
    state => state.checkout,
  );
  const isCartApiLoading = useAppSelector(state => state.cart.isCartApiLoading);

  const handleAdd = async () => {
    dispatch(setIsCartLoading(true));
    if (
      !cartData?.ID ||
      !storeData?.ShopID ||
      !storeData?.StoreID ||
      !addProduct ||
      !addProduct
    ) {
      dispatch(setIsCartLoading(false));
      return;
    }
    const lineItems = [
      {
        Quantity: 1,
        VariantID: addProduct,
      },
    ];

    const payload = {
      ID: cartData?.ID,
      LineItems: lineItems,
      ShopID: storeData?.ShopID,
      StoreID: Number(storeData?.StoreID),
      PageID: String(pageId) || '',
    };

    try {
      const res = await checkoutService.checkoutAddItem(payload, {
        preUpsellData: {} as UpSellData,
        cartData,
      });
      if (res?.data?.Cart) {
        dispatch(setCartData(res.data.Cart));
        dispatch(
          setAvailableShippingMethods(
            res.data.Cart.AvailableShippingMethods as ShippingMethod[],
          ),
        );
      }
    } catch (error: unknown) {
      if (error instanceof Error) {
        dispatch(setCheckoutErrorMessage(error.message)); // TODO: error message to sentry
      }
    } finally {
      dispatch(setIsCartLoading(false));
    }
  };
  const addToCart = async () => {
    if (addProduct) {
      const isProductInCart = cartData?.LineItems?.some(
        (item: { VariantID: string | number }) =>
          String(item.VariantID) === addProduct,
      );
      if (!isProductInCart) {
        await handleAdd();
      }
    }
  };

  return (
    <>
      <button
        onClick={async e => {
          e.preventDefault();
          dispatch(setIsTermsAccepted(true));
          await addToCart();
        }}
        style={{
          backgroundColor: styles?.backgroundColor,
          ...getBorderProps(styles.border, currentDeviceType),
          ...getPaddingStyles(styles.padding, currentDeviceType),
          transition: 'background-color 0.3s',
        }}
        disabled={
          isCartLoading || isSetShippingApiLoading > 0 || isCartApiLoading
        }
        onMouseOver={e => {
          e.currentTarget.style.backgroundColor = styles?.hoverColor;
        }}
        onMouseOut={e => {
          e.currentTarget.style.backgroundColor = styles?.backgroundColor;
        }}
        name="agree-continue-button"
        type="button"
        className={`${styles.width} bg-page_builder_theme ${styles.border?.borderStyle?.[currentDeviceType]}  border-transparent  ${Button.fontSize?.[currentDeviceType]} ${Button.weight?.[currentDeviceType]} text-white shadow-sm sm:order-last`}>
        <div
          className="items-center justify-center flex"
          style={{
            color: Button.textColor?.[currentDeviceType],
            transition: 'background-color 0.3s',
          }}
          onMouseOver={e => {
            if (Button?.hoverColor) {
              e.currentTarget.style.color =
                Button.hoverColor?.[currentDeviceType];
            }
          }}
          onMouseOut={e => {
            e.currentTarget.style.color = Button.textColor?.[currentDeviceType];
          }}
          dangerouslySetInnerHTML={{ __html: Button?.text }}></div>
        {(showVip || isEditPage) && ButtonText.text && (
          <p
            className={`${ButtonText.fontSize?.[currentDeviceType]} ${ButtonText.weight?.[currentDeviceType]} my-2 `}
            style={{
              color: ButtonText.textColor?.[currentDeviceType],
              transition: 'background-color 0.3s',
            }}
            onMouseOver={e => {
              if (ButtonText?.hoverColor) {
                e.currentTarget.style.color =
                  ButtonText.hoverColor?.[currentDeviceType];
              }
            }}
            onMouseOut={e => {
              e.currentTarget.style.color =
                ButtonText.textColor?.[currentDeviceType];
            }}
            dangerouslySetInnerHTML={{ __html: ButtonText?.text }}></p>
        )}
      </button>
    </>
  );
};
